import React from "react";
import BulkCreatePolygon from "../../components/BulkCreatePolygon";

const BulkCreatePolygonManager = (props) => {
    return <BulkCreatePolygon />;
};

export default BulkCreatePolygonManager;